import InnerComponent from '@Components/Admin/Customers';
import orgContainer from '@Components/AppContainer';

const ViewOrgAdmin = () => ((orgContainer(InnerComponent)));
export default ViewOrgAdmin;
